var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tags-input", {
    attrs: {
      "existing-tags": _vm.existingOptions,
      typeahead: true,
      "typeahead-style": "dropdown",
      "typeahead-max-results": _vm.maxResults,
      "typeahead-activation-threshold": _vm.activationThreshold,
      placeholder: _vm.placeholder,
      limit: 1,
      disabled: _vm.readonly,
      "hide-input-on-limit": true,
      "only-existing-tags": _vm.onlyExistingTags,
      "typeahead-hide-discard": _vm.typeaheadHideDiscard
    },
    on: {
      change: _vm.updateExistingOptions,
      "tag-added": _vm.onTagAdded,
      "tag-removed": _vm.onTagRemoved
    },
    model: {
      value: _vm.selectedOptions,
      callback: function($$v) {
        _vm.selectedOptions = $$v
      },
      expression: "selectedOptions"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }